import { useRef } from 'react';

const useThrottle = <T extends unknown[]>(
  callback: (...args: T) => void,
  delayMs: number
): ((...args: T) => void) => {
  const isThrottling = useRef(false);
  const timeoutId = useRef<number>();

  return (...args: T) => {
    if (isThrottling.current) return;

    isThrottling.current = true;
    callback(...args);

    if (timeoutId.current) window.clearTimeout(timeoutId.current);

    timeoutId.current = window.setTimeout(() => {
      isThrottling.current = false;
    }, delayMs);
  };
};

export default useThrottle;
